// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","orangeToWhite":"Button_orangeToWhite__IFTKM","black":"Button_black__CLFbn","white":"Button_white__r8eFt","orange":"Button_orange__iLs1A"};